import type { FaireProductEntity } from "../../entity_types/product";

export const p_myb8s65nkg: FaireProductEntity = {
  token: "p_myb8s65nkg",
  type: "product",
  name: "Pierce the Canned Cactus Eco-Friendly Plush w/Funny Jokes",
  brandToken: "b_d2r2bs3j23",
  brandName: "Canned Gifts",
  imageUrl:
    "https://cdn.faire.com/fastly/f3be1918d01d9ee5252cda01e13474a381323b28af7a18c1aba37b7c6e8b81c8.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2fbbe872411b2538fadcaff88bd8d5cc23ae82e1ce6ec6f244144713be01921d.png",
    "https://cdn.faire.com/fastly/16a9bd0799842029a8799ea50fdc9ced08a13cdad89acc78f550793f1c0030bf.png",
    "https://cdn.faire.com/fastly/880cc931c736132a21aacf478a9e21dfb2bd34a3bc2fd18766e70f2f22d9a56a.png",
    "https://cdn.faire.com/fastly/4585dde61489b57c7292e17b74f8f89904ede2c19d728312261f03c2471ef21b.png",
  ],
  priceDollars: 13.86,
  description:
    "Meet Pierce, our Canned Cactus! \n•\tPlush cactus sealed in a can. Use a can opener to open the fun gift or choose a pop top lid!\n•\tPlush measures approx. 5 inches.\n•\tFunny cactus jokes and an interesting fact on the can.\n•\tEco-friendly: fiber fill is made from 100% recycled plastics. Cloth label is made from recycled materials.\n•\tDesigned and canned in the USA. Can and label made in USA. Cactus made in Indonesia.\n\nsucculents cactus cacti plants garden decor gifts pots stuffed animal terrarium gift gardener gardening no maintenance Arizona New Mexico Arizona California Route 66 plant desert\n\n*Testers are a open can with the plush prepared for display",
  tags: [],
  msrpDollars: 27.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:11.843Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
